import Bowser from 'bowser';

export class Browser {
  public static get browserVersion() {
    return this.getInstance().browserVersion;
  }

  public static get browserName() {
    return this.getInstance().browserName;
  }

  public static get osVersion() {
    return this.getInstance().osVersion;
  }

  public static get osName() {
    return this.getInstance().osName;
  }

  public static get platformType() {
    return this.getInstance().platform;
  }

  public static get osBrand() {
    return this.getInstance().osBrand;
  }

  private static instance: Browser | null = null;

  private static getInstance() {
    if (!this.instance) {
      this.instance = new Browser();
    }
    return this.instance;
  }

  private browserVersion: string;
  private browserName: string;
  private osVersion: string;
  private osName: string;
  private platform: string | undefined;
  private osBrand: string | undefined;
  private browser: ReturnType<typeof Bowser.getParser>;

  private constructor() {
    this.browser = Bowser.getParser(window.navigator.userAgent);
    this.browserVersion = this.browser.getBrowserVersion();
    // It should be used in the default state so that the metrics sent to kibana are compatible with the old version.
    this.browserName = this.browser.getBrowserName();
    this.osVersion = this.browser.getOSVersion();
    // It should be used in the default state so that the metrics sent to kibana are compatible with the old version.
    this.osName = this.browser.getOSName();
    const platform = this.browser.getPlatform();
    this.platform = platform.type;
    this.osBrand = platform.vendor;
  }
}